// extracted by mini-css-extract-plugin
export default {"root":"ChatBar_root__9dTFe","selectorWrapper":"ChatBar_selectorWrapper__cVqS1","startButton":"ChatBar_startButton__bXUaq"};